import gql from 'graphql-tag'
import { ClientType } from '@dinosband/bv-apollo-client'
import { ChatRoomType } from '@dinosband/bv-main-schema/dist/types'
import { Message, OrderValue, QueryMessagesArgs } from '@dinosband/bv-messenger-schema'
import { _MESSAGE_DATA_PROPERTIES } from './const'

export async function queryCommentMessages (apollo: ClientType, userId: number, count = 20, excludeChatRoomIds: number[] = [], cursor?: number) {
  if (!apollo) {
    return []
  }
  const args: QueryMessagesArgs = {
    where: {
      userId: userId,
      chatRoomType: { equal: ChatRoomType.COMMENTS },
    },
    order: { id: OrderValue.Desc },
    limit: count,
  }
  if (excludeChatRoomIds?.length) {
    args.where = {
      ...args.where,
      chatRoomIds: { notIn: excludeChatRoomIds },
    }
  }
  if (cursor) {
    args.where = {
      ...args.where,
      id: { lte: cursor - 1 },
    }
  }
  try {
    const result = await apollo.query<{messages: Message[]}>({
      query: gql`query messages($where: MessagesWhereInput, $order: MessagesOrderInput, $limit: Int) {
      messages(where: $where, order: $order, limit: $limit) {
        ${_MESSAGE_DATA_PROPERTIES}
      }
    }`,
      variables: {
        ...args,
      },
      fetchPolicy: 'no-cache',
    })
    return result.data.messages
  } catch (e) {
  }
}

